// extracted by mini-css-extract-plugin
module.exports = {"section":"opportunities-preview_section__rGd34","sectionHeader":"opportunities-preview_sectionHeader__p7mA3","propertiesGrid":"opportunities-preview_propertiesGrid__oUjdz"};